module.exports = __webpack_public_path__ + "img/img_conference_2.3dd63179.png";